import {useRef} from 'react';
import {RemoveTeacherManager} from '../types';

export function useManagerRef() {
	return useRef<RemoveTeacherManager>(null);
}
